




























import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class UiHexagon extends Vue {

  @Prop() public size?: number;
  @Prop() public color?: string;
  @Prop() public borderSize?: number;
  @Prop() public borderColor?: string;

  private get viewBox(): string {
    const x0 = -this.innerBorderSize / 2;
    const y0 = -this.innerBorderSize / 2;
    const x1 = 40 + Number(this.innerBorderSize);
    const y1 = 40 + Number(this.innerBorderSize);
    return `${x0} ${y0} ${x1} ${y1}`;
  }

  private get innerSize(): number {
    return this.size ?? 40;
  }

  private get innerColor(): string {
    return this.color ?? 'grey';
  }

  private get innerBorderSize(): number {
    return  this.borderSize ?? 0;
  }

  private get innerBorderColor(): string {
    return this.borderColor ?? 'transparent';
  }

  private get cssVars() {
    const size: number = this.innerSize;
    const color: string = this.innerColor;
    const borderColor: string = this.innerBorderColor;
    return {
      '--inner-size': `${size}px`,
      '--color': color,
      '--border-color': borderColor,
    };
  }

  private click(event: MouseEvent): void {
    this.$emit('click', event);
  }

  private contextMenu(event: MouseEvent): void {
    this.$emit('contextmenu', event);
  }
}
